import angular from 'angular';
import moment from 'moment-timezone';
import { cloneDeep } from 'lodash';

const LISTING_MOCK = {
  "id": 238,
  "bathrooms": 3,
  "bedrooms": 4,
  "display_state": "pending",
  "price_cents": 21500000,
  "list_date": "2015-09-14",
  "lonlat": "POINT (-112.39215776324272 33.598430220476835)",
  "slug": "12552-N-154th-Ave-Surprise-AZ-85379",
  "square_footage": 2028,
  "view_count": 1620,
  "visit_count": 88,
  "address": {
    "id": 23167,
    "street": "12552 N 154th Ave",
    "street1": "12552 N 154th Ave",
    "unit": null,
    "state": "AZ",
    "city": "Surprise",
    "postal_code": "85379",
    "apn": "50146254",
    "latitude": "33.598401",
    "longitude": "-112.392154",
    "leads_count": 8,
    "created_at": "2015-08-16T10:32:43.026-07:00",
    "market": {
      "id": 1,
      "active": true,
      "identifier": "phoenix",
      "name": "Phoenix"
    }
  },
  "listing_photos": [
    {
      "id": 24392,
      "thumbnail_urls": {
        "_204x144": "https://d1k0cb7ed4to50.cloudfront.net/KrBdNNmIoHuasxOP3myApaPWDJ0=/204x144/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
        "_204x164": "https://d1k0cb7ed4to50.cloudfront.net/GdXHp5CtUZOL0KqzU-93Sf8yZdg=/204x164/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
        "_760x480": "https://d1k0cb7ed4to50.cloudfront.net/RjHlK1hfuZJZm8HqvEP1xxsM314=/760x480/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
        "_1800x1200": "https://d1k0cb7ed4to50.cloudfront.net/7EGleHQQZrtMd3snobx4Ze0VRu0=/1800x1200/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg" // eslint-disable-line max-len
      },
      "photo_url": "https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24392.jpg", // eslint-disable-line max-len
      "position": 0,
      "picable_type": "Listing",
      "picable_id": 238,
    },
    {
      "id": 24415,
      "thumbnail_urls": {
        "_204x144": "https://d1k0cb7ed4to50.cloudfront.net/bgpbZlaRpIQXTSGDUMBUR_6T314=/204x144/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
        "_204x164": "https://d1k0cb7ed4to50.cloudfront.net/pfQ3W7NbKVVgTsHW4krRclGcj7w=/204x164/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
        "_760x480": "https://d1k0cb7ed4to50.cloudfront.net/dgmMLRVb5t48RsAczFTw3Eg3BRg=/760x480/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
        "_1800x1200": "https://d1k0cb7ed4to50.cloudfront.net/8iveHGsfmUI5qQZA3RluamqnT8I=/1800x1200/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg" // eslint-disable-line max-len
      },
      "photo_url": "https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24415.jpg", // eslint-disable-line max-len
      "position": 1,
      "picable_type": "Listing",
      "picable_id": 238,
    },
    {
      "id": 24393,
      "thumbnail_urls": {
        "_204x144": "https://d1k0cb7ed4to50.cloudfront.net/OJSRrwYjVX3wwUmei6ZYj-CeK3Y=/204x144/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
        "_204x164": "https://d1k0cb7ed4to50.cloudfront.net/l-oCqs7N5A9BCUAatnZ6b3l1vEM=/204x164/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
        "_760x480": "https://d1k0cb7ed4to50.cloudfront.net/1PnMMzEYlws1wmyh1YbmOOXpIz0=/760x480/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
        "_1800x1200": "https://d1k0cb7ed4to50.cloudfront.net/p7t11vcKIlXgxArZPJhueHCXEBc=/1800x1200/https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg" // eslint-disable-line max-len
      },
      "photo_url": "https://listing-photos-production.s3.amazonaws.com/uploads/listing-238/24393.jpg", // eslint-disable-line max-len
      "position": 2,
      "picable_type": "Listing",
      "picable_id": 238,
    },
  ]
};

let upcomingListing = cloneDeep(LISTING_MOCK);
upcomingListing.display_state = "upcoming";
upcomingListing.list_date = moment().add(2, 'days').format("YYYY-MM-DD");

module.exports = angular.module('market.mocks.listing', [])
.value('listingMock', LISTING_MOCK)
.value('upcomingListingMock', upcomingListing)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/mocks/listing.js
 **/